import React from 'react'
import { NextSeo } from 'next-seo'
import { Title } from '@mantine/core'

import * as Types from '../../declarations'
import { getUploadThumbPath } from '../../lib/display'
import * as RedisUtil from 'lib/redis'
import PageTemplate from '../../components/PageTemplate'
import { withVersion } from '../../lib/withVersion'
import { TripList } from '../../components/TripList'

interface ExpeditionsPageProps {
	treks: Types.App.ExpeditionListTrip[]
	version: Types.VERSION
}

const ExpeditionsPage = ({ treks, version }: ExpeditionsPageProps) => {
	const seo = {
		title:
			version === Types.VERSION.TREKKING
				? 'Find guided treks - Guided Trekking'
				: 'Mountaineering Expeditions by Difficulty Height & Cost - Guided Peaks',
		description:
			version === Types.VERSION.TREKKING
				? 'Curated guide of treks for hikers, walkers, & trekkers. Information for each route to compare & find your best next route.'
				: 'Curated guide of peaks for climbers & mountaineers. Information for each route to compare & find your best next route.',
		canonical: `https://www.guided${
			version === Types.VERSION.TREKKING ? 'trekking' : 'peaks'
		}.com/expeditions`,
		siteName:
			version === Types.VERSION.TREKKING ? 'Guided Trekking' : 'Guided Peaks',
	}

	const seoImages = treks.slice(0, 5).map((trip) => ({
		url: getUploadThumbPath(trip.firstUploadId, 'large'),
		alt: trip.name,
		type: 'image/jpeg',
	}))

	return (
		<>
			<NextSeo
				title={seo.title}
				description={seo.description}
				canonical={seo.canonical}
				openGraph={{
					url: seo.canonical,
					title: seo.title,
					description: seo.description,
					images: seoImages,
					siteName: seo.siteName,
					type: 'website',
					locale: 'en_US',
				}}
			/>

			<PageTemplate>
				<Title order={1} mt="lg" mb="xl">
					{version === Types.VERSION.TREKKING
						? 'Explore treks & hikes around the world'
						: 'Explore expeditions on peaks around the world'}
				</Title>
				<TripList treks={treks} version={version} />
			</PageTemplate>
		</>
	)
}

export const getServerSideProps = withVersion(
	async (context: { version: Types.VERSION }) => {
		const trips = await RedisUtil.Data.ExplorePageData.get(
			{
				version: context.version,
			},
			// undefined,
			// true,
		)

		return { props: { treks: trips, version: context?.version } }
	},
)

export default ExpeditionsPage
